//export const properties = {    
const properties = {    
    productionUrl: "https://fascicolo.xyz",
    //productionUrl: "https://fascicolo.compagniadisanpaolo.it",
    version:"5.25",
    //verboseLog: 1,
    verboseLog: 0,
    //productionUrlSuffix: "/php_demo"
    productionUrlSuffix: "/php"
};

module.exports = { properties };